module.exports = __webpack_public_path__ + "static/media/glow.e98ce4e6.jpg";